import { TableCell, TableHead, TableRow, Typography } from '@mui/material'
import shared from '@/components/Settings/settingsShared.module.scss'

export default function InvoicesTableHead() {
  return (
    <TableHead>
      <TableRow className={shared.tableHeadRow}>
        <TableCell component="th" scope="col" className={shared.thCell}>
          <Typography variant="caption" color="text.secondary" className={shared.thCaption}>
            Invoice id
          </Typography>
        </TableCell>
        <TableCell component="th" scope="col" className={shared.thCell}>
          <Typography variant="caption" color="text.secondary" className={shared.thCaption}>
            Billing date
          </Typography>
        </TableCell>
        <TableCell component="th" scope="col" className={shared.thCell}>
          <Typography variant="caption" color="text.secondary" className={shared.thCaption}>
            Plan
          </Typography>
        </TableCell>
        <TableCell component="th" scope="col" className={shared.thCell}>
          <Typography variant="caption" color="text.secondary" className={shared.thCaption}>
            Amount
          </Typography>
        </TableCell>
        <TableCell component="th" scope="col" className={shared.thCell}>
          <Typography variant="caption" color="text.secondary" className={shared.thCaption}>
            Status
          </Typography>
        </TableCell>
        <TableCell component="th" scope="col" align="right" aria-label="Download invoice" className={shared.thCellActions} />
      </TableRow>
    </TableHead>
  )
}
